import {
  Grid,
  GridColumn as Column,
  GridToolbar,
} from "@progress/kendo-react-grid";
import React, { useEffect, useRef, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { process } from "@progress/kendo-data-query";
import { ExcelExport } from "@progress/kendo-react-excel-export";

import "./ExcelErrorRecords.scss";

function ExcelErrorRecords({ duplicateRecord }) {
  const [dataState, setDataState] = useState({
    skip: 0,
    take: 10,
  });
  const [result, setResult] = useState(
    process(
      duplicateRecord.map((dataItem) =>
        Object.assign({ selected: false }, dataItem)
      ),
      dataState
    )
  );
  let _export = useRef(null);

  useEffect(() => {
    setResult(
      process(
        duplicateRecord.map((dataItem) =>
          Object.assign({ selected: false }, dataItem)
        ),
        dataState
      )
    );
  }, [duplicateRecord]);

  const onDataStateChange = (event) => {
    setDataState(event.dataState);
    setResult(
      process(
        duplicateRecord.map((dataItem) =>
          Object.assign({ selected: false }, dataItem)
        ),
        event.dataState
      )
    );
  };

  const exportExcel = () => {
    toast.success(`Exporting ${duplicateRecord.length} records ...`,{autoClose: 40000});
    _export.save(duplicateRecord);
  };

  const getFileName = () => {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = today.getFullYear();

    today = dd + "/" + mm + "/" + yyyy;
    return `ErrorQualification_${today}`;
  };

  const fileName = getFileName();

  return (
    <div className="tableStyle excel-error-record">
      <div className="ExcelErrorHeading">Duplicate / InCorrect Record(s)</div>
      <ExcelExport fileName={fileName} ref={(exporter) => (_export = exporter)}>
        <Grid
          ScrollMode="scrollable"
          style={{ maxHeight: "500px",  width: 'auto' }}
          data={result}
          pageable
          {...dataState}
          total={result.length}
          filterable
          onDataStateChange={onDataStateChange}
          reorderable
        >
          <GridToolbar>
            <div>
              <button
                className="k-button k-primary"
                onClick={exportExcel}
                style={{ width: "116px" }}
              >
                Export to Excel
              </button>
            </div>
          </GridToolbar>
          <Column field="scacd" title="SCAC" />
          <Column field="modeOfTransport" title="Mode" />
          <Column field="originValue" title="Origin Port" />
          <Column field="originCountry" title="Origin Country / Region" />
          <Column field="originGeo" title="Origin Geo" />
          <Column field="destinationValue" title="Destination Port" />
          <Column field="destCountry" title="Destination Country / Region" />
          <Column field="destinationGeo" title="Destination Geo" />
          <Column field="servType" title="Commodity" />
          <Column field="qualified" title="Qualified Indicator" />
          <Column field="serviceLevel" title="Service Level" />
          <Column field="primaryOwner" title="Primary Owner" />
          <Column field="secondaryOwner" title="Secondary Owner" />
          <Column field="allocatIndicator" title="Allocation Indicator" />
          <Column field="remarks" title="Remarks" />
          <Column field="validFrom" title="Vaild From" />
          <Column field="validTo" title="Vaild To" />
          <Column field="Reason" title="Reason" />
        </Grid>
      </ExcelExport>
    </div>
  );
}

export default ExcelErrorRecords;
